import { Colors } from 'src/styles';
import styled, { css } from 'styled-components';

export const Label = styled.label<{ error?: boolean; nested?: boolean }>`
  font-weight: 700;
  display: block;

  ${({ error }) =>
    error &&
    css`
      color: ${Colors.error};
    `}

  ${({ nested }) =>
    nested &&
    css`
      font-weight: 400;
      /* aligned with checkbox */
      padding-left: 1.8rem;
    `}
`;
